var ThemeModePreference = /*#__PURE__*/function (ThemeModePreference) {
  ThemeModePreference["LIGHT"] = "light";
  ThemeModePreference["DARK"] = "dark";
  ThemeModePreference["SYSTEM"] = "system";
  return ThemeModePreference;
}(ThemeModePreference || {}); // Resolved ThemeModePreference
let ThemeMode = /*#__PURE__*/function (ThemeMode) {
  ThemeMode["LIGHT"] = "light";
  ThemeMode["DARK"] = "dark";
  return ThemeMode;
}({});

export { ThemeModePreference as T, ThemeMode as a };
//# sourceMappingURL=ThemeMode-DBlsP3Iq.js.map
